import {YouTubeVideo} from './youtube';
import {DateSchema, TrackSchema} from './schema';

export interface Model {}
export interface Controller {}

export interface PaginationInput {
  size: number | null;
  from: number | null;
}

export interface PaginationMeta {
  count: number;
  current_page: number;
  links?: Array<string>;
  per_page: number;
  total: number;
  total_pages: number;
}

export interface Slug {
  slug: string;
}

export interface Identity {
  identity: string;
}

export interface Featured {
  is_featured: number;
}

export interface Link {
  link: string;
}

export interface Tags {
  tags: TagMap;
}

export type TagMap = {
  hookd_genre?: Array<Tag>;
}

export interface Tag {
  slug: string;
  name: string;
  link: string;
}

export interface Size {
  width: number;
  height: number;
}

export interface Audio {
  spotify_preview: {
    url: string;
    waveform: string;
  };
}

export interface References {
  references?: {
    isrc?: Array<string>;
    spotify_track_id?: Array<string>;
  }
}

export interface SearchHit {
  [key: string]: any;
  objectID: string;
}

export interface Basket {
  identity: string;
  tracks: Array<TrackSchema>;
}

export interface BasketPatch {
  [identity: string]: number;
}

export interface HttpError extends Error {
  response: Response;
  body: any;
}

export interface APIError {
  success: boolean;
  error: string;
}

export interface Order extends Identity, Link {
  amount: OrderAmount;
  licences: Array<Licence>;
  locale: {
    country: string;
    currency: string;
  };
  status: string;
  stripe: {
    charge_id: string;
    order_id: string;
  }
  success: boolean;
}

export interface OrderAmount {
  card_fee: string;
  discount: string;
  total: string;
  vat: string;
}

export interface RateCard {
  name: string;
  rate: string;
  viewership: number;
}

export interface Licence extends Identity, Link {
  amount: string;
  claim: Array<Claim>;
  order: Order;
  date: DateSchema;
  order_id: string;
  quantity: number;
  track: TrackSchema;
}

export interface Claim {
  channel_id: string;
  claim_id: string;
  status: string;
  video_id: string;
  video?: YouTubeVideo;
}

export interface SearchFilter {
  [key: string]: any;
  attributeName: string;
  currentRefinement: Array<string>;
}

export interface SearchFilterDiff {
  add: SearchFilterDiffMap;
  remove: SearchFilterDiffMap;
}

export interface SearchFilterDiffMap {
  [type: string]: Array<string>
}

export interface BillingAddress {
  [field: string]: string;
  address1: string;
  address2?: string;
  city: string;
  country: string;
  postcode: string;
}

export interface LocationSuggestion {
  gmaps: {
    address_components: Array<{
      long_name: string;
      short_name: string;
      types: Array<string>;
    }>;
    formatted_address: string;
    geometry: any;
    place_id: string;
    types: Array<string>;
  };
  isFixture: boolean;
  label: string;
  location: {
    lat: number
    lng: number
  };
  placeId: string;
}

export interface FlashMessage extends Identity {
  time: number;
  type: FlashMessageType;
  props?: Object;
  seen: boolean;
}

export type FlashMessageType = string;
export type FlashMessageStyle = string;

export const FlashMessageTypeInfo: FlashMessageType = 'FlashMessageTypeInfo';
export const FlashMessageTypeError: FlashMessageType = 'FlashMessageTypeError';
export const FlashMessageTypeNoUser: FlashMessageType = 'FlashMessageTypeNoUser';
export const FlashMessageTypeOrderSuccess: FlashMessageType = 'FlashMessageTypeOrderSuccess';

export const FlashMessageStyleInfo: FlashMessageStyle = 'FlashMessageStyleInfo';
export const FlashMessageStyleSuccess: FlashMessageStyle = 'FlashMessageStyleSuccess';
export const FlashMessageStyleError: FlashMessageStyle = 'FlashMessageStyleError';